import { create } from 'zustand';

const initialState = {
    moduleName: null,
    responseData: [],
    filteredData: [],
    searchControls: [],
    addControls: [],
    isListChanged: true,
    filterControlValues: [],
    filterValues: null,
    hoverFilterValues: null,
    filterPayload: null,
    gridData: [],
};


export const useAppStore = create((set, get) => ({
    // State
    ...initialState,

    // Setters
    setModuleName: (name) => set({ moduleName: name }),
    setResponseData: (data) => set({ responseData: data }),
    setFilteredData: (data) => set({ filteredData: data }),
    setSearchControls: (data) => set({ searchControls: data }),
    setAddControls: (data) => set({ addControls: data }),
    setIsListChanged: (data) => set({ isListChanged: data }),
    setFilterControlValues: (data) => set({ filterControlValues: data }),
    setFilterValues: (data) => set({ filterValues: data }),
    setHoverFilterValues: (data) => set({ hoverFilterValues: data }),
    setFilterPayload: (data) => set({ filterPayload: data }),
    setGridData: (data) => set({ gridData: data }),




    // Reset store
    destroy: () => set({ ...initialState }),
    // Initialize with optional values
    initialize: (values = {}) => set({ ...initialState, ...values }),
}));